/**
 * Collection of design tokens representing various font weights. These tokens ensure typography
 * consistency across design elements.
 */ const fontWeights = {
    light: 340,
    normal: 400,
    medium: 500,
    bold: 580,
    bolder: 760
};

export { fontWeights };
//# sourceMappingURL=font-weights.js.map
